import React from "react";
import { Link } from "react-router-dom";
import useSeo from "../hooks/useSeo";

const NotFound = () => {
  useSeo({ title: "Page Not Found", description: "The page you're looking for doesn't exist.", path: "/404" });
  return (
    <div className="container-9one flex min-h-[60vh] flex-col items-center justify-center py-20 text-center animate-fade-in">
      <h1 className="font-display text-[28vw] leading-none tracking-tight sm:text-[180px]">404</h1>
      <p className="mt-2 label-mono text-ink/60">This page went out of stock</p>
      <Link to="/" className="btn-solid mt-8" data-testid="notfound-home-btn">
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
